import MaintenanceWorkflowForwardingCheckinEntrySection from "../../../Sections/CheckinEntry";
import MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection from "../../../Sections/EstablishmentChoiceEntry";

const DiagnosticEntryOnGoingEstablishmentChoice = () => {
  return (
    <>
      <MaintenanceWorkflowForwardingCheckinEntrySection />

      <MaintenanceWorkflowForwardingEstablishmentChoiceEntrySection />
    </>
  );
}

export default DiagnosticEntryOnGoingEstablishmentChoice;
